import React from "react";

const DashNotificationIcon = ({ width, height, color }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.79368 20C9.89009 20 10.7871 19.1 10.7871 18H6.80022C6.80022 19.1 7.69728 20 8.79368 20ZM14.7741 14V9C14.7741 5.93 13.1494 3.36 10.2888 2.68V2C10.2888 1.17 9.62097 0.5 8.79368 0.5C7.96639 0.5 7.29858 1.17 7.29858 2V2.68C4.44793 3.36 2.81329 5.92 2.81329 9V14L0.819824 16V17H16.7675V16L14.7741 14ZM12.7806 15H4.80675V9C4.80675 6.52 6.31182 4.5 8.79368 4.5C11.2755 4.5 12.7806 6.52 12.7806 9V15Z"
        fill={color || "#828282"}
      />
    </svg>
  );
};

export default DashNotificationIcon;
